// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1___45885ded537d416a092","cls2":"mentions_milestone_ping-cls2__dfbf82754403c51b0938 mentions_milestone_ping-cls1___45885ded537d416a092"};